<template>
  <div class="l_use_coupon_faq">
    <div class="container">
      <div class="content">
        <h3>クーポンを使うには</h3>
        <hr />
        <p>
          店舗やテイクアウトのお電話でのご利用の場合、クーポンのご利用画面をスタッフに見せることでご利用が可能です。ご希望のクーポンを選択した後、「クーポンを利用」ボタンを押してください。
        </p>
        <p>
          その後表示されるタイムスタンプをスタッフにお見せください。
        </p>
        <div style="display: flex">
          <div style="width: 1.25em; flex-shrink: 0; font-size: 14px">※</div>
          <p style="font-size: 14px">複数選択が可能になるのはアプリバージョン6.3.0以降です。</p>
        </div>
        <img :src="require('@/assets/img/faq/2308-c1.png')" alt="" />

        <div style="display: flex">
          <div style="width: 1.25em; flex-shrink: 0; font-size: 14px">※</div>
          <p style="font-size: 14px">クーポンにはご利用条件があります。「クーポンを利用」ボタンをタップする前に、ご利用条件のご確認をお願いいたします。</p>
        </div>
        <div style="display: flex">
          <div style="width: 1.25em; flex-shrink: 0; font-size: 14px"></div>
          <p style="font-size: 14px">また、複数選択中に「クーポンを利用」ボタンを押すと選択中のクーポン全てが利用中となりますのでご注意ください。</p>
        </div>

        <br />
        <p>
          テイクアウト可能なクーポンは、「ネット注文で使う」ボタンからご利用してください。利用するクーポンを選択後、「クーポンを利用」ボタンをタップしてWeb予約サービスへ遷移します。<br /><br />
        </p>
        <p>
          「店舗/お電話で使う」クーポンと「ネット注文で使う」クーポンは同時に選択できません。
        </p>
        <p>
          いずれかのご利用を完了させてから、改めてもう一方を選択し直してください。
        </p>
        <div style="display: flex">
          <div style="width: 1.25em; flex-shrink: 0; font-size: 14px">※</div>
          <p style="font-size: 14px">複数選択が可能になるのはアプリバージョン6.3.0以降です。</p>
        </div>

        <div class="l_button__external">
          <UIButton :label="'クーポンを使ってみる'" @click="tapLink" />
        </div>

        <h3 style="margin-top: 2em">フリーパスを使うには</h3>
        <hr />
        <p>
          フリーパスを獲得すると、クーポン画面にフリーパスが表示されます。「店舗/お電話で使う」「ネット注文で使う」いずれかのボタンからご利用してください。
        </p>
        <p>
          「店舗/お電話で使う」を選択された場合、「クーポンを利用」をタップした後、表示されるタイムスタンプをスタッフにお見せください。
        </p>
        <img :src="require('@/assets/img/faq/2308-c2.png')" alt="" />
        <div style="display: flex">
          <div style="width: 1.25em; flex-shrink: 0; font-size: 14px">※</div>
          <p style="font-size: 14px">フリーパスには、ご利用条件があります。ご利用条件のご確認をお願いいたします。</p>
        </div>
        
      
      </div>
    </div>
  </div>
</template>

<script>
import UIButton from '@/components/UIButton'
import { mapActions } from 'vuex'
import { FactoryTrack } from '../constant/firebase.js'

export default {
  name: 'FAQUseCoupon',
  components: {
    UIButton
  },
  created() {
    document.title = 'クーポンを使ってみよう'
  },
  methods: {
    ...mapActions('Native', ['actionNavigateTo']),
    ...mapActions('Analytics', ['trackEvent']),
    goBack: function () {
      this.$router.push({ name: 'FAQ' })
    },
    tapLink() {
      this.trackEvent(FactoryTrack.createTryCoupon())
      this.actionNavigateTo('2')
    },
    trapTrackEvent(id) {
      switch (id) {
        case 1:
          this.trackEvent(FactoryTrack.createFAQPremium())
          break
      }
    },
    tapAppSettingLink() {
      this.trackEvent(FactoryTrack.createSettingApp())
      this.actionNavigateTo('1') // 1:許諾画面
    }
  }
}
</script>

<style scoped>
.l_use_coupon_faq {
  width: 100%;
  min-height: 100%;
  background-color: #ffffff;
}

.l_use_coupon_faq h3,
.l_use_coupon_faq h4 {
  color: var(--accent-color);
}

.l_use_coupon_faq .container .content p {
  font-size: 16px;
  line-height: 1.5;
  color: #333333;
}

.l_use_coupon_faq .container .content .paragraph {
  font-size: 14px;
}

.l_use_coupon_faq .l_button__external {
  width: 250px;
  margin: 20px auto 0;
}
.l_use_coupon_faq .content {
  background-color: #ffffff;
  text-align: left;
  padding: 20px;
}
.l_use_coupon_faq .content hr {
  margin-top: 10px;
  margin-bottom: 20px;
  border: none;
  border-bottom: 1px solid var(--accent-color);
}
.l_use_coupon_faq .content img {
  margin-top: 20px;
  margin-bottom: 10px;
  max-width: 100%;
}
</style>
